import { useState } from 'react';

export default function useToken() {
  const getToken = () => {

    if (localStorage.getItem("username") != null) {
    const tokenString = localStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    
    if (userToken?.token && userToken.token.startsWith('eyJ')) {
      try {
        var base64Url = userToken.token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        var decoded = JSON.parse(jsonPayload);
        return decoded.isAdmin === true;
      } catch (e) {
        console.error("JWT decode error:", e);
        return false;
      }
    }
    
    return false;
    } 

    return false
    
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    localStorage.setItem('token', JSON.stringify(userToken));

    if (userToken?.token && userToken.token.startsWith('eyJ')) {
      try {
        var base64Url = userToken.token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        var decoded = JSON.parse(jsonPayload);
        setToken(decoded.isAdmin === true);
      } catch (e) {
        console.error("JWT decode error:", e);
        setToken(false);
      }
    } else {
      setToken(false);
    }
  };

  return {
    setToken: saveToken,
    token
  }
}
